// DS: i3.39
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioDraft: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M1 2a1 1 0 0 1 1-1h4.47a1 1 0 1 1 0 2H3v9H1V2Zm10.57-.36a.82.82 0 0 1 1.15 0l1.78 1.78a.82.82 0 0 1 0 1.16l-5.83 5.85a.82.82 0 0 1-.6.24l-1.69-.04a.82.82 0 0 1-.8-.77L5.5 8.12a.82.82 0 0 1 .24-.62l5.83-5.86ZM13 10h2v2h-2v-2ZM1 14a1 1 0 0 0 1 1h1v-2H1v1Zm14 0a1 1 0 0 1-1 1h-1v-2h2v1ZM4 13h2v2H4v-2Zm5 0H7v2h2v-2Zm1 0h2v2h-2v-2Z" />
      </svg>
    </IconWrap>
  );
};
StudioDraft.displayName = 'StudioDraft';

export default StudioDraft;
